import PropTypes from 'prop-types';
import * as React from 'react';
import { useComponentStylesLoaded } from '../../hooks/use-component-styles-loaded.js';
import { StepIndicatorContext } from './step-indicator-context.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { SWAN_STYLE_KEY_MAP } from '../head/stylesheets.component.js';
import { RenderComp } from '../core/render-comp.component.js';
var propTypes = {
  /**
  * The number of the currently active step
  */
  currentStepNumber: PropTypes.number.isRequired,

  /**
  * Specifies if all steps should be shown, or only the current step
  */
  showAllSteps: PropTypes.bool
};
var propKeysToRemove = Object.keys(propTypes);
var StepIndicator = renderWithRef('StepIndicator', propTypes, function (props, ref) {
  useComponentStylesLoaded('StepIndicator', SWAN_STYLE_KEY_MAP.stepIndicator);
  var currentStepNumber = props.currentStepNumber,
      showAllSteps = props.showAllSteps;
  var classNames = new Set(['swan-step-indicator']);
  if (showAllSteps) classNames.add('swan-step-indicator-show-all-steps');
  return /*#__PURE__*/React.createElement(StepIndicatorContext.Provider, {
    value: {
      currentStepNumber: currentStepNumber
    }
  }, /*#__PURE__*/React.createElement(RenderComp, {
    root: "div",
    forwardedRef: ref,
    propKeysToRemove: propKeysToRemove,
    classNames: classNames,
    props: props
  }, props.children));
});
StepIndicator.defaultProps = {
  currentStepNumber: 1
};
export { StepIndicator };